export default "__VITE_ASSET__CP7jHW57__"